angular.module('TetherApp').directive('lazyImages', ['$q', function ($q) {
    return {
        restrict: 'E',
        scope: {
            images: '='
        },
        link: function (scope, element, attribute) {
            scope.nextImage = function (index) {
                let nextIndex = index + 1;
                if (nextIndex < scope.images.length) {
                    scope.loadImage(nextIndex, scope.images[nextIndex]);
                }
            };
            scope.loadImage = function (index, src) {
                return $q(function(resolve,reject) {
                    let image = new Image();
                    image.src = src;
                    image.onload = function() {
                        resolve(image);
                    };
                    image.onerror = function(e) {
                        let paragraph = document.createElement("p");
                        let node = document.createTextNode("Unable to load image");
                        paragraph.appendChild(node);
                        reject(paragraph);
                    };
                }).then(
                    function (img) {
                        element.append(img);
                        scope.nextImage(index);
                    },
                    function (error) {
                        element.append(error);
                    }
                );
            };
            scope.$watch('images', function(images) {
                if (images == undefined
                    || images == null
                    || images.length <= 0) {
                    return;
                }
                scope.loadImage(0, images[0]);
            });
        }
    }
}]);
